import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { useSettingsStore } from "./store/settings";
import "./styles/globals.css";

// Apply persisted theme/density/contrast before first paint
useSettingsStore.getState().applyToDocument();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
